export var TIMELINE_START = 'timebarstartplay';
export var TIMELINE_END = 'timebarendplay';
export var VALUE_CHANGE = 'valuechange';
export var TIMEBAR_CONFIG_CHANGE = 'timebarConfigChanged';
export var PLAY_PAUSE_BTN = 'playPauseBtn';
export var NEXT_STEP_BTN = 'nextStepBtn';
export var PRE_STEP_BTN = 'preStepBtn';